import { post_api } from "api";
import { toast } from "react-toastify";

const logError = async (error, info) => {
    // Log the error to an external service
    console.error("Error caught by ErrorBoundary:", error, info);
    
    try {
        const messageBody = {
            errorMessage: error.message,
            componentStack: info.componentStack,
            timestamp: new Date().toISOString(),
        };
        const { data, message } = await post_api("error", messageBody);
        toast.success(message);
        return data;
    } catch (err) {
        toast.error(err.message);
    }
};

export default logError;
